import { useState } from "react";
import Header from "../Header";
import useUser from "../../hook/useUser"
import { MdBiotech } from "react-icons/md";
import { FaArrowRight } from "react-icons/fa";

const Dashboard = () => {

const { user, error } = useUser();

// for count completed lesson
const preJobProgress = user?.modules?.generalTraining?.preJobPreparation?.progress;
const lessonsCompletedText = Number(preJobProgress) === 100 ? "1/6" : "0/6";

// for count completed quiz
const preJobScore = user?.quizResult?.score;
const quizCompletedText =Number(preJobScore) >= 70 ? "1/6" : "0/6" ;

//for total progress
const totalProgress = Math.round((preJobProgress ?? 0) / 6);

//for Pre-job progress


    return (
        <>
        <div className="dashboard-inner">
        <Header />
        <h1 className="dashboard-h1">Welcome, {user ? user.employeeName : "Loading..."} </h1>
        

        <div className="overview-wrapper">
            <h3>Overview</h3>
            <div className="overview-inner">
                
                <div className="lesson-completed">
                    <p>Lessons completed</p>
                    <div>{lessonsCompletedText}</div>
                </div>
                <div className="quiz-completed">
                    <p>Quiz completed</p>
                    <div>{quizCompletedText}</div>
                </div>
                <div className="average-score">
                    <p>Average score</p>
                    <div>{preJobScore}%</div>
                </div>
                <button style={{ cursor: "pointer" }}>Continue Training <FaArrowRight /></button>
            </div>

            <h3>Your progress</h3>
            <div className="total-progress-inner">
                <p>Total progress</p>
                <div className="total-progress-bar">
                    <div className="total-progress-bar-fill" style={{ width: `${totalProgress}%` }}>
                        <span>{totalProgress}%</span>
                    </div>
                </div>
            </div>

            <div className="progress-bars-inner">
                <h4>Pre-job Preparation</h4>
                <div className="pre-job-progress-bar">
                    <div className="pre-job-progress-bar-fill" style={{ width: `${preJobProgress}%` }}>
                        <span>{preJobProgress}%</span>
                    </div>
                </div>
                

                <h4>Basic Skills</h4>
                <progress id="basic-skills-progress-bar" max="100" value={0}></progress>

                <h4>Breka Culture</h4>
                <progress id="breka-culture-progress-bar" max="100" value={0}></progress>

                <h4>Server Basic Skills</h4>
                <progress id="server-skills-progress-bar" max="100" value={0}></progress>

                <h4>Bartender Skills</h4>
                <progress id="bartender-skills-progress-bar" max="100" value={0}></progress>

                <h4>Drink Recipe</h4>
                <progress id="drink-progress-bar" max="100" value={0}></progress>
            </div>

            <div className="schedule-inner">
                <h2>Schedule</h2>

                <div className="schedule-card">
                    <p className="schedule-title">Pre-job preparation</p>
                    <p>Start date: Mar 11th</p>
                    <p>Due: Apr 10th at 11:59PM</p>
                </div>
                <div className="schedule-card">
                    <p className="schedule-title">Basic Skills</p>
                    <p>Start date: Mar 11th</p>
                    <p>Due: Apr 10th at 11:59PM</p>
                </div>
                <div className="schedule-card">
                    <p className="schedule-title">Breka Culture</p>
                    <p>Start date: Mar 11th</p>
                    <p>Due: Apr 10th at 11:59PM</p>
                </div>
                <div className="schedule-card">
                    <p className="schedule-title">Server Basic Skills</p>
                    <p>Start date: Mar 11th</p>
                    <p>Due: Apr 10th at 11:59PM</p>
                </div>
                <div className="schedule-card">
                    <p className="schedule-title">Bartender Skills</p>
                    <p>Start date: Mar 11th</p>
                    <p>Due: Apr 10th at 11:59PM</p>
                </div>
                <div className="schedule-card">
                    <p className="schedule-title">Drink Recipe</p>
                    <p>Start date: Mar 11th</p>
                    <p>Due: Apr 10th at 11:59PM</p>
                </div>
            </div>
        </div>

        </div>
        </>
    );

}

export default Dashboard;